// Gallery override: definitive thumbnail, swipe, and modal handling for product pages.
(function() {
  function getActiveId(root) {
    var active = root.querySelector('.product-media--featured[data-active="true"]');
    return active ? active.getAttribute('data-id') : null;
  }
  
  function showImage(root, id) {
    var featured = root.querySelectorAll('.product-media--featured');
    featured.forEach(function(f) {
      if (f.parentNode && f.parentNode.style) f.parentNode.style.display = '';
      f.style.display = '';
      f.setAttribute('data-active', f.getAttribute('data-id') === id ? 'true' : 'false');
    });
    var thumbs = root.querySelectorAll('.product-media--thumb');
    thumbs.forEach(function(t) {
      t.setAttribute('data-active', t.getAttribute('data-id') === id ? 'true' : 'false');
    });
  }
  
  function getOrderedIds(root) {
    var ids = [];
    root.querySelectorAll('.product-media--thumb').forEach(function(t) {
      var id = t.getAttribute('data-id');
      if (id) ids.push(id);
    });
    return ids;
  }
  
  function stepImage(root, dir) {
    var ids = getOrderedIds(root);
    if (ids.length < 2) return;
    var cur = getActiveId(root);
    var i = ids.indexOf(cur);
    if (i < 0) i = 0;
    var n = (i + dir + ids.length) % ids.length;
    showImage(root, ids[n]);
  }

  function initGalleryOverride() {
    var roots = document.querySelectorAll('product-media-root');
    if (!roots.length) return;
    
    roots.forEach(function(root) {
      // --- THUMBNAIL TAPS (capturing) ---
      root.addEventListener('click', function(e) {
        var thumb = e.target.closest('.product-media--thumb');
        if (!thumb) return;
        var id = thumb.getAttribute('data-id');
        if (!id) return;
        e.stopPropagation();
        e.preventDefault();
        showImage(root, id);
      }, true);
      
      // --- SWIPE ON MAIN IMAGE ---
      var featuredWrap = root.querySelector('.product-page--featured-media');
      if (featuredWrap) {
        var startX = null, startY = null;
        // shared flag to suppress modal-open click right after a swipe
        if (typeof window.__gallerySwiped === 'undefined') window.__gallerySwiped = false;
        featuredWrap.addEventListener('touchstart', function(e) {
          if (e.touches.length === 1) {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
          }
        }, {passive: true});
        featuredWrap.addEventListener('touchend', function(e) {
          if (startX === null) return;
          var dx = e.changedTouches[0].clientX - startX;
          var dy = e.changedTouches[0].clientY - startY;
          startX = null; startY = null;
          // horizontal swipe with minimal vertical movement
          if (Math.abs(dx) > 60 && Math.abs(dy) < 80) {
            e.preventDefault();
            window.__gallerySwiped = true;
            setTimeout(function(){ window.__gallerySwiped = false; }, 500);
            stepImage(root, dx < 0 ? 1 : -1);
          }
        });
      }
    });
    
    // --- MODAL: open the currently-viewed image (deterministic) ---
    // Intercept in capturing phase on document to beat theme handlers
    document.addEventListener('click', function(e) {
      // suppress modal open immediately after a swipe gesture
      if (window.__gallerySwiped) return;
      var link = e.target.closest('.modal--link');
      if (!link) return;
      var modalRoot = link.closest('modal-root');
      if (!modalRoot || modalRoot.getAttribute('data-modal-view') !== 'product-media') return;
      
      // Find the currently active gallery image
      var galleryRoot = document.querySelector('product-media-root');
      var activeId = galleryRoot ? getActiveId(galleryRoot) : null;
      if (!activeId) return; // let theme handle it
      
      e.stopPropagation();
      e.preventDefault();
      
      // Find the slide index matching the active image
      var contents = modalRoot.querySelectorAll('.modal--content');
      var idx = 0;
      contents.forEach(function(cEl, i) {
        if (cEl.querySelector('.product-page--modal-image[data-id="' + activeId + '"]')) idx = i;
      });
      
      // Open the modal at the correct index via the element's open method
      if (typeof modalRoot.open === 'function') {
        modalRoot.open(idx);
      }
    }, true);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryOverride);
  } else {
    initGalleryOverride();
  }
})();
